'use client';

import { useTranslations } from 'next-intl';

import { DocsLinks } from '@/components/how-it-works/docs-links';
import { Coins01Icon, FlashIcon, LinkForwardIconSolid } from '@/components/ui/icon/glyphs';
import { InfoModal } from '@/components/ui/info-modal';

interface ReferralsHowItWorksDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function ReferralsHowItWorksDialog({
  open,
  onOpenChange,
}: ReferralsHowItWorksDialogProps): React.ReactNode {
  const t = useTranslations('social.referrals');

  return (
    <InfoModal
      open={open}
      onOpenChange={onOpenChange}
      size="lg"
      title={t('how_it_works')}
      description={t('how_it_works_intro')}
      footer={<InfoModal.Footer cta={t('got_it')} onClose={(): void => onOpenChange(false)} />}
    >
      <InfoModal.IconList>
        <InfoModal.IconItem
          icon={LinkForwardIconSolid}
          title={t('how_it_works_step1_title')}
          description={t('how_it_works_step1_desc')}
        />
        <InfoModal.IconItem
          icon={Coins01Icon}
          title={t('how_it_works_step2_title')}
          description={t('how_it_works_step2_desc')}
        />
        <InfoModal.IconItem
          icon={FlashIcon}
          title={t('how_it_works_step3_title')}
          description={t('how_it_works_step3_desc')}
        />
      </InfoModal.IconList>
      <InfoModal.Callout>{t('how_it_works_tiers')}</InfoModal.Callout>
      <DocsLinks docsPath="/guides/referrals" />
    </InfoModal>
  );
}
